/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { useTranslation } from "react-i18next";
import "react-reflex/styles.css";
import layoutConf from "../../config/layoutConf";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { debounce } from 'lodash';
import TkProcessSelectionByOrderBuyerDetail from "./TkProcessSelectionByOrderDetail";

function TkProcessSelectionByOrder(props) {

    const id = "TkProcessSelectionByOrder";
    const view = "TkVwOrderBuyerMstNotDelivered"

    const { t } = useTranslation();

    const [grid, setGrid] = useState();
    const [height, setHeight] = useState(0);

    const [onSelectMst, setOnSelectMst] = useState();

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);

    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([]);

                    };

                }, 10));

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setOnSelectMst(grid.selectedItems[0])

                    } else {

                        setOnSelectMst([]);

                    };

                }, 10));
            }

        })()

    }, [grid])

    const onGridInitialized = (grid) => {

        grid.selectionMode = "Row";
        
        setGrid(grid);

    };

    return (

        <div style={{ height: height }}>

            <ReflexContainer orientation="vertical">

                <ReflexElement flex={0.35}>

                    <BasicCrudScreenType
                        id= {id}
                        headerTitle={t("term.so")}
                        view={view}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onInitialized={onGridInitialized}
                    />

                </ReflexElement>

                <ReflexSplitter
                    style={{ width: layoutConf.reflex.splitterWidth }}
                />

                <ReflexElement flex = {0.65}>

                {
                    onSelectMst 
                    ?
                    <TkProcessSelectionByOrderBuyerDetail
                        onSelectMst={onSelectMst}
                        
                    />
                    :
                    <></>
                }


                </ReflexElement>

            </ReflexContainer>

        </div>

    );

}

export default TkProcessSelectionByOrder;
